module.exports = __webpack_public_path__ + "image/quality_banner.jpg";